import Select, { DropdownIndicatorProps, components } from 'react-select';
import { DownCaretIcon } from '../assets/svgImages';
import { PrescriptionProps } from '../constant/constant';
import {
  BulkEmaiUserSelectionProps,
  FiltersState,
  SelectProps,
} from '../interface/interface';
import useToFetchAllProducts from '../hooks/useToFetchAllProducts';
import { useEffect, useState } from 'react';
import { useAuth } from 'react-oidc-context';
import Loading from './Loading';

const BulkEmailPrescriptionSelection = (props: BulkEmaiUserSelectionProps) => {
  const [productList, setProductList] = useState<Array<SelectProps>>([]);
  const [fetchAllProducts, loading] = useToFetchAllProducts();
  const { user } = useAuth();

  useEffect(() => {
    fetchAllProducts(user?.access_token).then((res) => setProductList(res));
  }, [user?.access_token]);

  const DropdownIndicator = (props: DropdownIndicatorProps<true>) => {
    return (
      <components.DropdownIndicator {...props}>
        <DownCaretIcon />
      </components.DropdownIndicator>
    );
  };
  if (loading) return <Loading />;

  return (
    <>
      <div className="flex align-items">
        <div className="me-5">
          <label className="text-lg font-semibold text-secondary-pink-700">
            Prescription Status <span className="text-red-500">*</span>
          </label>
          <Select
            className="w-72 cursor-pointer"
            value={
              props.filters?.prescriptionStatus?.value
                ? (props.filters.prescriptionStatus as any)
                : undefined
            }
            options={PrescriptionProps as any}
            onChange={(selected) =>
              props.setFilters((prev: FiltersState | undefined) => ({
                ...prev!,
                prescriptionStatus: selected as any,
              }))
            }
            components={{
              DropdownIndicator,
              IndicatorSeparator: () => null,
            }}
          />
        </div>
        <div>
          <label className="text-lg font-semibold  text-secondary-pink-700">
            Patient Type <span className="text-red-500">*</span>
          </label>
          <Select
            className="w-72 cursor-pointer"
            value={
              props.filters?.product?.value
                ? (props.filters.product as any)
                : undefined
            }
            options={productList as any}
            onChange={(selected) =>
              props.setFilters((prev: FiltersState | undefined) => ({
                ...prev!,
                product: selected as any,
              }))
            }
            components={{
              DropdownIndicator,
              IndicatorSeparator: () => null,
            }}
          />
        </div>
      </div>
      <div className='mt-5'>
        <label className="flex items-center space-x-3 mb-2">
          <input
            type="checkbox"
            name="invited"
            id="invited"
            className={`form-checkbox h-5 w-5 text-primary-blue-500 mt-1 cursor-pointer`}
            checked={props.filters?.ignoreIfAlreadySent}
            onChange={() =>
              props.setFilters((prev: FiltersState | undefined) => ({
                ...prev!,
                ignoreIfAlreadySent: !prev?.ignoreIfAlreadySent,
              }))
            }
          />
          <span className={`text-md text-primary-blue-500 cursor-pointer`}>
            Ignore if already sent
          </span>
        </label>
      </div>
    </>
  );
};

export default BulkEmailPrescriptionSelection;
